// extracted by mini-css-extract-plugin
export var arrow = "_cn-1";
export var content = "_cn-0";
export var highlighted = "_cn-2";